import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './application-page/login/login.component';
import { ResetPasswordComponent } from './application-page/reset-password/reset-password.component';
import { LogoutComponent } from './application-page/logout/logout.component';
import { ForgetPasswordComponent } from './application-page/forget-password/forget-password.component';
import { AuthGuard } from './auth/auth.guard';
import { UnAuthGuard } from './auth/un-auth.guard';
import { ResetPasswordGuard } from './auth/reset-password.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, data: { title: 'login' }, canActivate: [UnAuthGuard] },
  // { path: 'logout', component: LogoutComponent, data: { title: 'logout' } },
  { path: 'forget-password', component: ForgetPasswordComponent, canActivate: [UnAuthGuard] },
  { path: 'reset-password/:token', component: ResetPasswordComponent},
  { path: 'resetPassword/:token', component: ResetPasswordComponent },
  {
    path: '',
    loadChildren: () => import('../app/application-page-with-menu/application-page-with-menu.module').then(m => m.ApplicationPageWithMenuModule),
    canActivate: [AuthGuard]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
